import { http } from "../api/http";
import Utils from "../utils";

export const runbookSystemService = {
  getAll,
  get,
  getById,
  create,
  update,
  remove,
};

async function getAll() {
  let url = "/runbooksystem/getall";

  return await http.get(url).then((response) => {
    return response;
  });
}

function get(requestParameters) {
  let url = `/runbooksystem?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getById(requestParameters) {
  let url = `/runbooksystem/byid?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function create(requestBody) {
  let url = `/runbooksystem/create`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function update(requestBody) {
  let url = `/runbooksystem/update`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function remove(requestParameters) {
  let url = `/runbooksystem/delete?${Utils.objectToQueryString(requestParameters)}`;

  return http.delete(url).then((response) => {
    return response;
  });
}
